import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatGoalStateModel } from 'src/app/model/cat-goal-state.model';
import { CatGoalStateService } from 'src/oldApp/services/cat-goal-state.service';

@Component({
  selector: 'app-modal-goal-state',
  templateUrl: './modal-goal-state.component.html',
  styleUrls: ['./modal-goal-state.component.css']
})
export class ModalGoalStateComponent implements OnInit {
  @Input() state:CatGoalStateModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=1;

  // marcaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  ////////////////
  constructor(
    private catGoalStateService:CatGoalStateService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() { }

  //
  updateCommission=e=> this.state.commission=!e || e.trim()===''?null:Number(e);
  updateCommissionFisofo=e=> this.state.commissionFisofo=!e || e.trim()===''?null:Number(e);

  toggleActive=()=> this.state.activeId=!this.state.activeId;
  toggleActiveFisofo=()=> this.state.activeIdFisofo=!this.state.activeIdFisofo;

  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(this.commissionErrorFisofo()) errors.push('Necesita capturar una comisión de Fisofo.');

    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.state.stateDescription=this.state.stateDescription.toUpperCase();
      this.catGoalStateService.save(this.state)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La meta se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la meta.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  descriptionError=()=> !this.state.stateDescription || this.state.stateDescription.trim()==='';
  commissionError=()=> !this.state.commission;
  commissionErrorFisofo=()=> !this.state.commissionFisofo;

}
